import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SetPreferredFreelancersOnlyCollection } from './set-preferred-freelancers-only.types';

export function setPreferredFreelancersOnlyBackend(): Backend<SetPreferredFreelancersOnlyCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: (authUid, document) => ({
      endpoint: `admin/setPreferredFreelancersOnly.php`,
      method: 'POST',
      isGaf: true,
      payload: {
        projectId: document.id,
        action: document.action,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
